import type { ExposureEvent } from '@types';

/**
 * Normalizza eventi exposure persistiti: foodIds → itemIds (legacy).
 */
export function normalizeExposureEvent(event: unknown): ExposureEvent | null {
  if (!event || typeof event !== 'object') return null;
  const e = event as Record<string, unknown>;
  const type = e.type;
  const timestamp =
    typeof e.timestamp === 'number'
      ? e.timestamp
      : typeof e.timestamp === 'string'
        ? Date.parse(e.timestamp)
        : NaN;

  if (type === 'tutorialCompleted') {
    return { type: 'tutorialCompleted', timestamp };
  }
  if (type === 'sessionStartedAt') {
    return { type: 'sessionStartedAt', timestamp };
  }
  if (type === 'sessionEndedAt') {
    return { type: 'sessionEndedAt', timestamp };
  }
  if (type === 'mealEnded') {
    return {
      type: 'mealEnded',
      timestamp,
      clientId: typeof e.clientId === 'string' ? e.clientId : undefined,
    };
  }

  const rawIds = e.itemIds ?? e.foodIds;
  const itemIds = Array.isArray(rawIds)
    ? rawIds
        .map(v => (typeof v === 'number' ? v : Number(v)))
        .filter(n => Number.isFinite(n))
    : [];

  if (type === 'itemShown' || type === 'foodShown') {
    return { type: 'itemShown', timestamp, itemIds };
  }
  if (type === 'itemFeedback' || type === 'foodFeedback') {
    return {
      type: 'itemFeedback',
      timestamp,
      itemIds,
      score: typeof e.score === 'number' ? e.score : Number(e.score) || 0,
    };
  }

  return null;
}

export function getExposureEventItemIds(event: {
  itemIds?: number[];
  foodIds?: number[];
  foodId?: number;
}): number[] {
  if (Array.isArray(event.itemIds) && event.itemIds.length > 0) {
    return event.itemIds;
  }
  if (Array.isArray(event.foodIds) && event.foodIds.length > 0) {
    return event.foodIds;
  }
  if (typeof event.foodId === 'number') return [event.foodId];
  return [];
}
